export default __webpack_public_path__ + "static/media/leaves_bg.46ade36d.jpg";